import script from "./PortalAppCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalAppCard.vue?vue&type=script&setup=true&lang=js"

import "./PortalAppCard.vue?vue&type=style&index=0&id=615f967a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615f967a"]])

export default __exports__